import type { ReactNode } from "react";

interface StatCardProps {
  icon?: ReactNode;
  label: string;
  value: ReactNode;
}

const StatCard = ({ icon, label, value }: StatCardProps) => (
  <div className="flex min-h-[88px] items-center gap-4 rounded-[22px] border border-slate-200/80 bg-white/95 p-4 shadow-[0_10px_24px_rgba(15,23,42,0.06)] transition motion-safe:duration-200 dark:border-white/10 dark:bg-slate-950/60">
    {icon ? (
      <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-indigo-50 text-xl text-indigo-600 dark:bg-indigo-400/15 dark:text-indigo-200">
        {icon}
      </span>
    ) : null}
    <div className="min-w-0">
      <p className="text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-300">{label}</p>
      <p className="mt-1 truncate text-xl font-bold text-slate-950 dark:text-white">{value}</p>
    </div>
  </div>
);

export default StatCard;
